<template>
  <div class="vz-docs-tree-item">
    <vz-collapse-info
      v-for="childItem in item.children"
      :key="childItem.id"
      :initial-show="childItem.id === route.query.id"
    >
      <template #header>
        {{ childItem.name }}
      </template>
      <vz-docs-tree-item
        :docs="docs"
        :item="childItem"
        hide-title
      />
    </vz-collapse-info>
    <div
      v-for="(doc, index) in currentDocs"
      :key="index"
      class="vz-docs-tree-item-last"
    >
      <vz-icon
        url="/svg/pdf.svg"
        variant="primary"
        size="24"
        class="mr-15"
        no-masked-icon
      />
      <a
        :href="getUrl(doc)"
        target="_blank"
      >
        {{ doc.name }}
      </a>
    </div>
  </div>
</template>

<script setup lang="ts">
import { PropType } from 'vue'
import { IDocument, IDocumentTreeItem } from '~/types/api'
import VzCollapseInfo from '~/components/ui-kit/vz-collapse-info.vue'

const props = defineProps({
  docs: {
    type: Array as PropType<IDocument[]>,
    default: () => []
  },
  item: {
    type: Object as PropType<IDocumentTreeItem>,
    default: () => ({})
  }
})

const route = useRoute()

const currentDocs = computed(() => {
  return props.docs.filter(doc => doc.category_id === props.item.id)
})

function getUrl (item: IDocument): string {
  return `/article/download/?id=${item.description}`
}
</script>